import { createAsyncThunk } from '@reduxjs/toolkit';
import { LegalService } from '../services/legal.service';
import { GuardianInfo } from '../types/legal.types';
import { showCriticalAlert } from './common.actions';
import i18n from '../i18n';

export const fetchGuardianInfo = createAsyncThunk(
    'legal/fetchGuardianInfo',
    async (_, { rejectWithValue, dispatch }) => {
        try {
            const guardianInfo = await LegalService.getGuardianInfo();
            return guardianInfo;
        } catch (error) {
            dispatch(showCriticalAlert(i18n.t('epic.common.network.error')));
            return rejectWithValue(
                error instanceof Error ? error.message : 'Unknown error occurred'
            );
        }
    }
);

export const updateGuardianInfo = createAsyncThunk(
    'legal/updateGuardianInfo',
    async (guardianData: GuardianInfo, { rejectWithValue }) => {
        try {
            const updatedGuardianInfo = await LegalService.updateGuardianInfo(guardianData);
            return updatedGuardianInfo;
        } catch (error) {
            return rejectWithValue(
                error instanceof Error ? error.message : 'Unknown error occurred'
            );
        }
    }
);
